module.exports = "https://cdn.hellotech.com/client-assets/smart-home-mobile_2b1e445c7173db7f080675016ca120ab.jpg";